import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { string, oneOfType, number, bool, arrayOf } from 'prop-types';
import { productImageSizes } from '../../constants';
import { Image } from './responsive-image.styles';

const ResponsiveImage = _ref => {
  let {
    src,
    srcSetDensity,
    imageWidth,
    imageHeight,
    width,
    height,
    lazy
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["src", "srcSetDensity", "imageWidth", "imageHeight", "width", "height", "lazy"]);

  if (!src) return /*#__PURE__*/React.createElement(React.Fragment, null);
  const imgProps = Object.assign({}, props, {
    width: imageWidth,
    height: imageHeight,
    src: src.replace('{w}', width).replace('{h}', height)
  });
  const srcSet = srcSetDensity.map(density => {
    const item = src.replace('{w}', width * density).replace('{h}', height * density);
    const targetDensity = density > 1 ? ` ${density}x` : '';
    return `${item}${targetDensity}`;
  }).join(', ');
  if (srcSet) imgProps.srcSet = srcSet;
  if (lazy) imgProps.loading = 'lazy';
  return /*#__PURE__*/React.createElement(Image, _extends({
    "data-testid": "image"
  }, imgProps));
};

process.env.NODE_ENV !== "production" ? ResponsiveImage.propTypes = {
  height: oneOfType([string, number]),
  lazy: bool,
  src: string,
  srcSetDensity: arrayOf(number),
  width: oneOfType([string, number]),
  imageWidth: oneOfType([string, number]),
  imageHeight: oneOfType([string, number])
} : void 0;
ResponsiveImage.defaultProps = {
  height: productImageSizes.height,
  lazy: true,
  src: '',
  srcSetDensity: [],
  width: productImageSizes.width,
  imageWidth: '',
  imageHeight: ''
};
export default ResponsiveImage;